import { BrowserRouter as Router } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import AppContainer from './containers';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { lightTheme } from '@gojitsu/web-ui-core';

import './App.css';

const theme = createTheme({
  ...lightTheme,
  typography: {
    ...lightTheme.typography,
    fontFamily: ['AvenirNext', '-apple-system', 'sans-serif'].join(','),
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightLight: 300,
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <RecoilRoot>
        <Router>
          <AppContainer />
        </Router>
      </RecoilRoot>
    </ThemeProvider>
  );
}

export default App;
